import type { ReactNode } from 'react';
import { Button, Dialog, Modal, ModalOverlay } from 'react-aria-components';

import styles from './CommandPalette.module.css';

export interface CommandPaletteProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  /** The dialog's accessible name, e.g. "Patient search". */
  title: string;
  /** Usually a `SearchPicker` with `autoFocus`. */
  children: ReactNode;
  /** One line of keyboard help under the results, e.g. "Enter opens the patient. Esc closes." */
  hint?: string;
}

/**
 * A floating search layer opened with a shortcut (Ctrl/⌘K for patients). It sits near the
 * top of the screen so results have room below, uses the floating radius and shadow, and
 * closes on Escape or a click outside with focus returned to where it was.
 */
export function CommandPalette({
  isOpen,
  onOpenChange,
  title,
  children,
  hint,
}: CommandPaletteProps) {
  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      isDismissable
      className={styles.overlay}
    >
      <Modal className={styles.modal}>
        <Dialog className={styles.dialog} aria-label={title}>
          {/* Shown on phones only, where there is no Esc key. */}
          <Button slot="close" className={styles.close}>
            Close
          </Button>
          {children}
          {hint === undefined ? null : <p className={styles.hint}>{hint}</p>}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
